import React from 'react'
import Grid from '@mui/material/Grid'
import { Fade } from 'react-awesome-reveal'
import { SITE_NAME } from '../../../../../constants'
import { Container } from '@mui/material'
import Image2 from 'images/wholesale/002.svg'
import { Trans, useTranslation } from 'react-i18next'

const TITLE_COLOR = '#F0AE16'

const DoItSection: React.FC = () => {
  const { t } = useTranslation()
  return (
    <section className='md:pb-30 overflow-hidden -mt-30 lg:-mt-60' style={{ backgroundColor: '#F2EEEA' }}>
      <Container maxWidth='lg'>
        <h2 className='text-5xl md:text-6xl text-center mb-10 font-semibold' style={{ color: TITLE_COLOR }}>
          {t('wholesale.doItWithSite', { defaultValue: 'Do it with {{siteName}}', siteName: SITE_NAME })}
        </h2>
        <p className='text-center text-xl md:text-3xl md:mb-60 leading-tight'>
          {t(
            'wholesale.provideOurDesigns',
            'Provide our designs to your customers and you can be sure they will be satisfied'
          )}
        </p>
        <Grid container spacing={0}>
          <Grid item xs={12} md={8}>
            <div className='md:h-600 flex justify-center'>
              <img src={Image2} alt='Do it image' className='max-h-full max-w-full' draggable={false} />
            </div>
          </Grid>
          <Grid item xs={12} md={4}>
            <Fade triggerOnce direction='right' cascade>
              <div className='flex flex-col justify-center h-full text-center md:text-left pt-20 md:pt-0'>
                <div className='mb-20'>
                  <h3 className='text-4xl mb-10 font-semibold' style={{ color: TITLE_COLOR }}>
                    {t('wholesale.highProfitMargin', 'High Profit Margin')}
                  </h3>
                  <p className='text-lg leading-relaxed'>
                    <Trans i18nKey='wholesale.giveYouTheBestPrice'>
                      We give you the best wholesale price possible.
                      <br />
                      You can earn up to 100% profit.
                    </Trans>
                  </p>
                </div>

                <div className='mb-20'>
                  <h3 className='text-4xl mb-10 font-semibold' style={{ color: TITLE_COLOR }}>
                    {t('wholesale.buildAnAssortment', 'Build an Assortment')}
                  </h3>
                  <p className='text-lg leading-relaxed'>
                    <Trans i18nKey='wholesale.eachDayWeProduceNewDesigns'>
                      Each day we produce new designs. <br />
                      You and your customers will find what you need-we promise.
                    </Trans>
                  </p>
                </div>

                <div className='mb-20'>
                  <h3 className='text-4xl mb-10 font-semibold' style={{ color: TITLE_COLOR }}>
                    {t('wholesale.maintainLoyalCustomers', 'Maintain Loyal Customers')}
                  </h3>
                  <p className='text-lg leading-relaxed'>
                    {t(
                      'wholesale.customersLoveOurProducts',
                      '99% of our customers love our products and leave 5-star reviews.'
                    )}
                  </p>
                </div>
              </div>
            </Fade>
          </Grid>
        </Grid>
      </Container>
    </section>
  )
}

export default DoItSection
